module.exports = __webpack_public_path__ + "c88cecbffad6d8e731fd95de49561ebd.ttf";